import { render } from "./BuyLivesDialog.vue?vue&type=template&id=4a13e322&scoped=true&ts=true"
import script from "./BuyLivesDialog.vue?vue&type=script&lang=ts"
export * from "./BuyLivesDialog.vue?vue&type=script&lang=ts"

import "./BuyLivesDialog.scss?vue&type=style&index=0&id=4a13e322&scoped=true&lang=scss"

import exportComponent from "/var/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a13e322"]])

export default __exports__